var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "picker-wrapper", class: { active: _vm.activePicker } },
    [
      _c("span", { staticClass: "caption ft-xbld" }, [
        _vm._v(_vm._s(_vm.caption)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "outer", staticClass: "picker-outer", class: _vm.uniqueClass },
        [
          _c(
            "div",
            {
              staticClass: "dft-preview",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.togglePicker.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "lft" }, [
                _c("span", {
                  staticClass: "clr",
                  style: { backgroundColor: this.colorTxt },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "txt ft-bld" }, [
                  _vm._v(_vm._s(this.colorTxt)),
                ]),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "arw",
                class: { spin: _vm.activePicker },
              }),
            ]
          ),
          _vm._v(" "),
          _c("ChromePicker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activePicker,
                expression: "activePicker",
              },
            ],
            on: { input: _vm.onColorChange },
            model: {
              value: _vm.color,
              callback: function ($$v) {
                _vm.color = $$v
              },
              expression: "color",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }